import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrgChart, OrgLevelNode, UserOrgAssignment, OrgAssignmentRequest, RepInfo } from '../models/org-chart.model';

@Injectable({ providedIn: 'root' })
export class OrgChartService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/core/org-chart';
  private readonly userApiUrl = '/api/core/user';

  getAll(): Observable<OrgChart[]> {
    return this.http.get<OrgChart[]>(this.apiUrl);
  }

  create(request: { name: string; jsonStructure?: string }): Observable<OrgChart> {
    return this.http.post<OrgChart>(this.apiUrl, request);
  }

  update(uuid: string, request: { name?: string; jsonStructure?: string; isActive?: boolean }): Observable<OrgChart> {
    return this.http.put<OrgChart>(`${this.apiUrl}/${uuid}`, request);
  }

  delete(uuid: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${uuid}`);
  }

  getTree(uuid: string): Observable<OrgLevelNode> {
    return this.http.get<OrgLevelNode>(`${this.apiUrl}/${uuid}/tree`);
  }

  getRepsByLevel(chartUuid: string): Observable<Record<string, RepInfo[]>> {
    return this.http.get<Record<string, RepInfo[]>>(`${this.apiUrl}/${chartUuid}/level-reps`);
  }

  getUserAssignments(userUuid: string): Observable<UserOrgAssignment[]> {
    return this.http.get<UserOrgAssignment[]>(`${this.userApiUrl}/${userUuid}/org-assignments`);
  }

  updateUserAssignments(userUuid: string, assignments: OrgAssignmentRequest[]): Observable<UserOrgAssignment[]> {
    return this.http.post<UserOrgAssignment[]>(`${this.userApiUrl}/${userUuid}/org-assignments`, assignments);
  }
}
